import { render, staticRenderFns } from "./UserLogin.vue?vue&type=template&id=efb81fae&scoped=true&"
import script from "./UserLogin.vue?vue&type=script&lang=js&"
export * from "./UserLogin.vue?vue&type=script&lang=js&"
import style0 from "./UserLogin.vue?vue&type=style&index=0&id=efb81fae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efb81fae",
  null
  
)

export default component.exports